<template>
    <div class="h-100">
        <b-alert :show="!!errorHandlingMessage" variant="danger" dismissible>{{ errorHandlingMessage }}</b-alert>
        <!-- <div class="mb-2 d-flex justify-content-between align-items-end">
            <div>
                <h4 class="mb-0">{{ title }}</h4>
            </div>
            <div>
                <b-link 
                    v-if="pdfComplete"
                    :disabled="!hasPdf"
                    class="font-weight-500 font-size-80 text-uppercase"
                    @click="downloadPdf"
                >
                    <b-icon icon="download" class="mr-1"></b-icon>
                    Download
                </b-link>
            </div>
        </div> -->  <!-- integrated this stuff below -->
        
        <!-- <div v-if="loadingTask" key="loadingReport" class="h-100 w-100 min-height-400">
            <busy-spinner text="Preparing the PDF..."></busy-spinner>
        </div> -->

        <div v-if="!loadingTask && !taskStateOk" key="noReportAvailable" class="d-flex justify-content-center align-items-center min-height-200 bg-gray-100 border rounded-lg">
            <div class="text-center">
                <p class="mb-0 text-uppercase text-muted font-weight-500">Report is not yet submitted, so report is not available.</p>
            </div>
        </div>

        <div v-else key="reportIsAvailable" class="border rounded-lg overflow-hidden bg-gray-200">
            <div
                ref="pdfControlBar" 
                class="d-flex gap-3 align-items-center justify-content-between p-2 bg-dark"
            >
                <div class="d-flex justify-content-start align-items-center gap-1">
                    <b-button :disabled="(currentPage <= 1) || !hasPdfDataUrl" variant="ondark-light" class="font-weight-500 font-size-80 text-uppercase" @click="currentPage--">&larr; Previous</b-button>
                    <b-icon icon="file-earmark-text" :class="!hasPdfDataUrl ? 'text-' : 'text-white'"></b-icon>
                    <b-button :disabled="(currentPage >= pageCount) || !hasPdfDataUrl" variant="ondark-light" class="font-weight-500 font-size-80 text-uppercase" @click="currentPage++">Next &rarr;</b-button>
                </div>
                <div>
                    <div class="text-white font-weight-bold">
                        <transition name="fade-fast" mode="out-in">
                            <span v-if="!hasPdfDataUrl" key="noDataUrl">Loading...</span>
                            <span v-else key="hasDataUrl">
                                <span class="font-weight-300">Page</span> {{ currentPage }} <span class="font-weight-300">of</span> {{ pageCount }}
                            </span>
                        </transition>
                    </div>
                </div>
                <div>
                    <b-button
                        :disabled="!hasPdfDataUrl"
                        variant="ondark-light"
                        class="font-weight-500 font-size-80 text-uppercase"
                        @click="downloadPdf"
                    >
                        <b-icon icon="download" class="mr-1"></b-icon>
                        Download
                    </b-button>
                </div>
            </div>

            <div 
                class="embed-area-outer"
                :style="pdfEmbedOuterStyle"
            >  <!-- we set the height on this one -->

                <transition name="fade-fast" mode="out-in">
                    <vue-pdf-embed
                        v-if="pdfDataUrl"
                        key="pdfLoaded"
                        ref="vuePdfEmbedRef"
                        :source="pdfDataUrl"
                        :page="currentPage"
                        class="pdf-embed-wrapper"
                        :style="pdfEmbedInnerStyle"
                        @rendered="handlePdfEmbedRender"
                    ></vue-pdf-embed>

                    <div 
                        v-else 
                        key="loadingPdf" 
                        class="h-100 d-flex justify-content-center align-items-center"
                    >
                        <busy-spinner text="Preparing the PDF..."></busy-spinner>
                    </div>
                </transition>
            
            </div>

        </div>

        <!-- <div 
            id="pdf-iframe-wrapper" 
            ref="pdf-iframe"
            class="w-100 h-100"
        ></div> -->
        
        <!-- <div>
            <pre>{{ schema }}</pre>
        </div> -->
        <!-- <workflow-form-formio task-id="xP1mOLuaRhB67r6R4Sys2p"></workflow-form-formio> -->
    </div>
</template>

<script>
import { errorHandling, tenantInfoMixin, splUrlMapMixin } from "../../js/custom-vue-mixins";
import { suppliosApi } from '../../js/api-service';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import { 
    FormatDateHelper, 
    //FormatDateTimeHelper 
} from '../../js/filters-helpers';

/* 
MUST HAVE THESE SCRIPTS ON THE PAGE (or install via npm)
https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.4/pdfmake.min.js
https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.4/vfs_fonts.min.js
https://cdn.jsdelivr.net/npm/pdfjs-dist@2.12.313/build/pdf.min.js
*/


const docDef = {
    info: {
        title: 'Quality Issue Report',  // - the title of the document
        author: 'Supplios',  //  - the name of the author
        //subject: '',  //  - the subject of the document
        //keywords: '',  //  - keywords associated with the document
        creator: 'Supplios',  //  - the creator of the document (default is ‘pdfmake’)
        producer: 'Supplios',  //  - the producer of the document (default is ‘pdfmake’)
        // creationDate: '',  //  - the date the document was created (added automatically by pdfmake)
        // modDate: '',  //  - the date the document was last modified - MH IS NOT SURE OF TYPE -- Date?  or String?
        //trapped: '',  //  - the trapped flag in a PDF document indicates whether the document has been “trapped”, i.e. corrected for slight color misregistrations
    },
    header: {
        columns: [
            "",
            "",
        ],
        color: 'gray',
        fontSize: 10,
        margin: [20, 20, 20, 20],
    },
    /* footer: {
        columns: ["Nifco America", { text: "CONFIDENTIAL", alignment: "right" }],
        color: 'gray',
        fontSize: 10,
        margin: [20, 20, 20, 20],
    }, */
    content: [
        // build dynamically
    ],
    styles: {
        aboveTitle: {
            fontSize: 18,
            bold: true,
            color: "#999999",
            margin: [0, 0, 0, 20],
        },
        title: {
            fontSize: 30,
            bold: true,
            margin: [0, 0, 0, 0],
        },
        firstpage: {
            margin: [0, 250, 0, 50],
        },
        pageTitle: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 20],
        },
        panelLabel: {
            color: 'darkblue',
            bold: true,
            margin: [0,10,0,0],  // bottom margin of 0 because you have line under it
        },
        fieldLabel: {
            fontSize: 12,
            bold: true,
            margin: [0, 0, 0, 5],
        },
        fieldGroup: {
            margin: [0, 0, 0, 0], // not great, since you will have uneven margin around nested layout components
        },
        header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10],
        },
        subheader: {
            fontSize: 16,
            bold: true,
            margin: [0, 10, 0, 5],
        },
        tableExample: {
            margin: [0, 5, 0, 15],
        },
        tableHeader: {
            bold: true,
            fontSize: 13,
            color: "black",
        },
    },
    defaultStyle: {
        // alignment: 'justify'
    },
    /* images: {
        //companyLogo: 'https://supplios-content-useast1.s3.amazonaws.com/media/public/public-files/logos/orgbnvowgrq23dh/nifco-logo.png',
        //acmeLogo: 'https://supplios-content-useast1.s3.amazonaws.com/media/public/public-files/logos/orgt2vql1eim7os/acme-logo-new-2.png',
        //suppliosLogoDark: 'https://hq.supplios.com/static/img/supplios_0705_dark.png',
        //suppliosLogoWhite: 'https://hq.supplios.com/static/img/supplios_0705_dark.png',
        suppliosLogoDark: '/static/img/supplios_0705_dark.png',
        suppliosLogoWhite: '/static/img/supplios_0705_dark.png',
    }, */
};

/* const svgHorizLine = { 
    svg: '<svg viewBox="0 0 500 10"><line x1="0" y1="5" x2="500" y2="5" stroke="black" /></svg>',
    margin: [0,5,0,5],
}; */

/* const makeSvgLine = () => {
    return { 
        svg: '<svg viewBox="0 0 500 10"><line x1="0" y1="5" x2="500" y2="5" stroke="black" /></svg>',
        margin: [0,5,0,5],
    };
} */

const makePanelTitle = (text) => {
    return {
        layout: 'lightHorizontalLines',
        margin: [0,5,0,5],
        table: {
            widths: ['*'],
            //headerRows: 1,
            body: [
                [
                    {
                        text: text,
                        //fillColor: '#eeeeee',
                        //border: [false, false, false, false],
                        bold: true,
                        color: 'darkblue',
                        //paddingLeft: 20,
                    }
                ],
                ['']  // a 'dummy row' below header to show horizontal line -- can unset headerRows: 1 to show a light line, or keep it to show heavy line
            ]
        }
    }
}

const makeTocPage = () => {
    return {
        pageBreak: 'before',
        toc: {
            title: {text: 'Table of Contents', style: 'pageTitle'}
        }
    };
}

// helper to go through array of possibly nested formio components and pull out only input components
const getInputComponents = (componentArray) => {
    // return ONLY components that have input: true
    const inputCompsFlat = [];
    const addIfInputComp = (comp) => {  // the function we'll use recursively
        if (comp.input) {  // add the component itself, if input
            inputCompsFlat.push(comp);
        }
        if (comp.components) {  // if the component has children components, do those too
            comp.components.forEach(childComp => addIfInputComp(childComp));
        }
        if (comp.columns) {  // have to check columns too
            comp.columns.forEach(colComp => addIfInputComp(colComp));
        }
    };
    componentArray.forEach(comp => {
        addIfInputComp(comp); // will go through recursively 
    });
    return inputCompsFlat;  // return whatever you put in here
}

class FormioComponent {
    constructor(formioObj, level, parentPath = '', allData, fileUrls) {
        // parentPath is string of parent 'path' if this is a NESTED component (ie: data structure has this as a key/value in parent, not in parent components array)
        this.level = level;
        // gotta set key and path first, so we can pass to children
        this.key = formioObj.key;
        this.path = parentPath ? `${parentPath}.${this.key}` : this.key;
        this.type = formioObj.type;
        this.input = formioObj.input ?? false;
        this.isInputComponent = this.input;  // just for better readability
        const nestedContainerTypes = ['container', 'selectboxes'];  // MAYBE MORE! these 'type' values means it is a nested container, child components should have nested path
        this.isNestedContainer = nestedContainerTypes.includes(this.type);
        const alreadyHandledKeys = ['key', 'path', 'type', 'input', 'level'];
        Object.entries(formioObj).forEach(([key, value]) => {
            if (alreadyHandledKeys.includes(key)) {
                return;  // if we already manually handled this key above, then just go next
            }
            if (key === 'components' || key === 'columns') {  // for column components, the array is in 'columns' not components
                const childLevel = this.level + 1;
                const parentPathForChild = this.isNestedContainer ? this.path : '';
                // check components and columns, but we'll always output to components in our own objects
                this['components'] = value.map(comp => new FormioComponent(comp, childLevel, parentPathForChild, allData, fileUrls));  // make components recursively
            } else {
                // if not components key, just set it
                this[key] = value;  // just assigne everything as class property 
            }
        });
        // GET DATA -- pass in full data object, we'll pull from there based on this.key
        const defaultValue = ''; // `Data for path ${this.path}`;
        this.value = this.isInputComponent ? get(allData, this.path, defaultValue) : null;
        if (this.type === 'datetime') {
            this.value = this.value ? FormatDateHelper(this.value) : '';
        }
        // handle FILES -- swap the URLS from this.fileUrls
        // ACTUALLY NO -- all we need is image: fileId -- and we will add the 'fresh' urls to the images: key in documentDefinition
        /* const getCurrentFileUrl = (formioFileValueObj) => {
            const fileId = formioFileValueObj?.data?.id;
            const newUrl = fileUrls[fileId];  // undefined if not there, or didn't pass in
            return newUrl ?? '';
        } */
        /* const getFileId = (formioFileValueObj) => {
            return formioFileValueObj?.data?.id;
        }
        if (this.type === 'file') {
            if (Array.isArray(this.value)) {
                // NO - we should pass through the entire file value 'object' so we can look at the filetype and stuff like that to determine how to output it
                //this.value = this.value.map(val => getFileId(val));
                this.value = this.value;  // stupid... just remove this section...
            } else {
                //this.value = getFileId(this.value);
                this.value = this.value;  // stupid...
            }
        } */
        // then we'll output things differently depending on properties
    }
    forPdf({
        imageDict = {},  // object of all images ready to go - with keys of the image name/id, values as URL or dataURL
    } = {}) {
        // NEW - Feb 3 2022 -- pass in 'context data' type stuff - like images, and other things needed in output
        if (this.hidden === true) {
            return null;
        }
        if (this.type === 'content' && this.input === false) {
            // if its just an instructions content thing, don't output it for now
            // but don't do this with anything that has nested stuff you care about!  instead, just ignore the title line
            return null;
        }
        const pdfObj = {stack: []};
        // PART 1 - HANDLE TITLE / LABEL
        if (this.level === 0) {
            pdfObj['pageBreak'] = 'before';
            pdfObj['style'] = 'pageContent';
            pdfObj.stack.push({text: (this.title || this.label), style: 'pageTitle', tocItem: true});
        } else {
            pdfObj['style'] = 'fieldGroup';
            const noTitleTypes = ['columns'];  // we won't output the title/label for these components - maybe all layout components?
            if (noTitleTypes.includes(this.type)) {
                // do not include title for these
            } else if (this.type === 'panel') {
                // for panels, we'll sometimes show them, sometimes not
                const isPanelCollapsed = this.collapsed === true;
                const isLabelHidden = this.hideLabel === true;
                const isInstructions = this.title === 'Instructions';
                if (isPanelCollapsed || isLabelHidden || isInstructions) {
                    // don't show for these
                } else {
                    const panelTitle = makePanelTitle((this.title || this.label));
                    pdfObj.stack.push(panelTitle);
                    //pdfObj.stack.push({text: (this.title || this.label), style: 'panelLabel'});
                    //pdfObj.stack.push(makeSvgLine());
                }
            } else if (!this.hideLabel) {
            //if (!noTitleTypes.includes(this.type)) {  // don't show title/label for panels... will be redundant
                pdfObj.stack.push({text: (this.title || this.label), style: 'fieldLabel'});
            }
        }

        // PART 2 - HANDLE CHILDREN OR VALUE (should be one or the other)

        // always return SOMETHING -- if no value, then output this
        const makeEmptyValue = () => {  // call this to output object to use for any 'empty' value
            return {text: 'Not Provided', color: 'gray', margin: [5,0,0,10]};
        }

        var childObj;  // will add different types depending on what we're dealing with
    
        if (this.type === 'selectboxes') {
            const labelValueObjectArray = this.values;
            const valueLabelMapping = Object.fromEntries(this.values.map(selectOption => ([selectOption.value, selectOption.label])));
            console.log('FOUND SELECTBOXES - value is', this.value);
            console.log('values are:', labelValueObjectArray);
            // value is an object of string: true/false -- just output the strings -- but have to get labels...
            const selectedKeys = [];
            Object.entries(this.value).forEach(([selectKey, isSelected]) => {
                if (isSelected) {
                    selectedKeys.push(selectKey);
                }
            });
            const selectedLabels = selectedKeys.map(key => valueLabelMapping[key]);
            const selectedKeysJoined = selectedKeys.join(', ');
            const selectedLabelsJoined = selectedLabels.join(', ');
            console.log('selected things:');
            console.log('keys: ', selectedKeysJoined);
            console.log('labels: ', selectedLabelsJoined);
            childObj = selectedLabelsJoined ? {text: selectedLabelsJoined, margin: [5,0,0,10]} : makeEmptyValue();
        } else if (this.type === 'radio') {
            // get the label for the selected value -- maybe should have done this earlier in constructor?  Or should we always get raw value there, then presentation value here?  makes sense
            const radioValueLabelMapping = Object.fromEntries(this.values.map(val => ([val.value, val.label])));
            if (this.value) {
                const radioLabel = radioValueLabelMapping[this.value];
                childObj = {text: radioLabel, margin: [5,0,0,10]};
            } else {
                childObj = makeEmptyValue();
            }
        } else if (this.type === 'datagrid' && this.components) {
            // DATA GRID
            // make table with key and label 
            if (!this.value) {
                childObj = makeEmptyValue();
            } else {
            
                const dataGridVisibleCols = this.components.filter(comp => !comp.hidden);
                const dateComponentKeys = dataGridVisibleCols.filter(comp => comp.type === 'datetime').map(c => c.key);
                const dataGridKeys = dataGridVisibleCols.map(comp => comp.key);
                const dataGridHeaderRow = dataGridVisibleCols.map(comp => {
                    return {
                        text: comp.label,
                        italics: true,
                        //fillColor: '#eeeeee',
                    };
                });
                const makeDataGridRow = (valueRow) => {
                    return dataGridKeys.map(key => {
                        const rowVal = valueRow[key];
                        return dateComponentKeys.includes(key) ? FormatDateHelper(rowVal) : rowVal;
                    });
                }
                const dataGridRows = this.value.map(row => makeDataGridRow(row));
                childObj = {
                    margin: [0,0,0,10],
                    layout: 'lightHorizontalLines',
                    table: {
                        // headers are automatically repeated if the table spans over multiple pages
                        // you can declare how many rows should be treated as headers
                        headerRows: 1,
                        //widths: [ '*', 'auto', 100, '*' ],
                        body: [
                            [...dataGridHeaderRow], ...dataGridRows,
                        ]
                    }
                };
            }
        } else if (this.type === 'editgrid') {
            // EDIT GRID - child components may be in other layout components
            if (!this.value) {
                childObj = makeEmptyValue();
            } else {
                const editGridInputComps = getInputComponents(this.components);
                // make table using key and label
                const editGridVisibleCols = editGridInputComps.filter(comp => !comp.hidden);
                const dateComponentKeys = editGridVisibleCols.filter(comp => comp.type === 'datetime').map(c => c.key);
                const editGridKeys = editGridVisibleCols.map(comp => comp.key);
                const editGridHeaderRow = editGridVisibleCols.map(egComp => {
                    return {
                        text: egComp.label,
                        italics: true,
                        //fillColor: '#eeeeee',
                    };
                });
                const makeEditGridRow = (valueRow) => {
                    return editGridKeys.map(key => {
                        const rowVal = valueRow[key];
                        return dateComponentKeys.includes(key) ? FormatDateHelper(rowVal) : rowVal;
                    });
                }
                const editGridRows = this.value.map(row => makeEditGridRow(row));
                childObj = {
                    margin: [0,0,0,10],
                    layout: 'lightHorizontalLines',
                    table: {
                        // headers are automatically repeated if the table spans over multiple pages
                        // you can declare how many rows should be treated as headers
                        headerRows: 1,
                        //widths: [ '*', 'auto', 100, '*' ],
                        body: [
                            [...editGridHeaderRow], ...editGridRows,
                        ]
                    }
                };
            }
        } else if (this.components) {
            // HANDLE CHILD COMPONENTS (including columns component) - only if not handling them above
            const childCompsArray = this.components.map(comp => comp.forPdf({imageDict})).filter(pObj => !!pObj); // the filter is to remove any where we return null
            const parentComponentStyle = `${this.type}Style`; // so we can style each type of layout component
            // if this is a panel, put a svg line above / below it?
            if (this.type === 'panel') {
                //pdfObj.stack.push(makeSvgLine());
            }
            if (childCompsArray.length) {
                if (this.type === 'columns') {
                    childObj = {columns: childCompsArray, style: parentComponentStyle};  // if its columns, put in columns, if not, then put in stack
                } else {
                    // if NOT columns, but other thing that has child components
                    childObj = {stack: childCompsArray, style: parentComponentStyle};
                }
            }
        } else if (this.type === 'file') {
            // might have array of fileIds or single one 
            // NEW - we passed through the entire formio file value OBJECT here, not just the ID -- so we can use other things in the value object to determine how to display it
            // but to show the file, we still just need the file ID in image: fileId - use helper function below
            const getFileId = (formioFileValueObj) => (formioFileValueObj?.data?.id);
            const getFileMimeType = (formioFileValueObj) => (formioFileValueObj?.type ?? '');  // will be 'image/jpeg' or 'image/png' or 'application/pdf' or something
            // need to check mime type to know if we should try displaying as image or not
            const imageMimeTypes = ['image/jpeg', 'image/png'];  // these are the only image types that pdfmake can show
            const isImageFile = (formioFileValueObj) => {
                const mimetype = getFileMimeType(formioFileValueObj);
                return imageMimeTypes.includes(mimetype);
            };
            const getFileName = (formioFileValueObj) => (formioFileValueObj?.originalName ?? '');
            console.log('FILE', this.key, this.value);
            const imageFitParams = [500,500];  // will fit in this box, not stretched?
            const outputFileForPdf = (fileValueObj) => {
                // NOTE - we really should check to make sure we have the key for this image in our pdf 'images' dictionary... but since this component is outside the vue instance, we can't... consider it later
                if (isImageFile(fileValueObj)) {
                    const fileId = getFileId(fileValueObj);  // might be falsey...
                    return fileId ? {image: fileId, fit: imageFitParams} : null;
                } else {  // if NOT an image file
                    const fileName = getFileName(fileValueObj);
                    return fileName ? {text: `${fileName} (download in app)`} : null;
                }
            }
            if (Array.isArray(this.value)) {
                // may be a mix of 'text' objects and 'image' objects
                const fileArray = this.value.map(fileValueObj => outputFileForPdf(fileValueObj)).filter(obj => !!obj);  // remove any where you returned null
                if (fileArray.length) {
                    childObj = {stack: fileArray};
                }
            } else if (this.value) {  // if value is only a SINGLE file, not array
                const filePdfOutput = outputFileForPdf(this.value);  // might be null
                if (filePdfOutput) {
                    childObj = filePdfOutput;  // only add childObj if we have something
                }
            } else {
                // childObj = makeEmptyValue();  - don't do this... I think... just don't output anything, which will hide the who component
            }
        } else {
            // if no child components, then its just a data/input field -- display the value 
            // HANDLE DATA
            // MUST CHECK TYPES!!!
            const valueIsEmpty = (this.value === '') || (Array.isArray(this.value) && this.value.length === 0);  // more options for empty?
            const valueAsString = (typeof this.value === 'string') ? this.value : JSON.stringify(this.value);
            //const finalValue = valueIsEmpty ? 'Not Provided' : valueAsString;
            //const valueColor = valueIsEmpty ? 'gray' : 'black';
            childObj = valueIsEmpty ? makeEmptyValue() : {text: valueAsString, margin: [5,0,0,10]};
        }
        if (childObj) {
            // push the childObj into the stack if you have one
            pdfObj.stack.push(childObj);
        }

        // NOW add any EXTRAS (like images, etc.)
        const extraObjects = [];
        if (this.properties?.reportImage) { // do we have a reportImage to add as an extra? 
            const reportImageKey = this.properties.reportImage;  // something like 'fishbone'
            // IMPORTANT - you MUST make sure you actually added this to the documentDefinition!  
            // NEW - Feb 3 2022 - we are now passing in 'imageDict' -- object with all the images - so we can make sure its there before adding it here 
            if (reportImageKey in imageDict) {
                extraObjects.push({image: reportImageKey, fit: [500,500]});
            } else {
                console.warn(`Tried to add reportImageKey ${reportImageKey} to report, but it is not in our image dictionary so we will skip it`);
            }
        }
        // did you actually add anything?  if so, push into pdfObj.stack
        if (extraObjects.length) {
            extraObjects.forEach(eo => pdfObj.stack.push(eo));
        } 

        // finally, we ONLY add the top level pdfObj to the report if it has a childObj OR extraObj
        if (childObj || extraObjects.length) {
            return pdfObj;
        } else {
            // if no childObj, then don't return anything -- otherwise we'll have empty titles/pages
            return null;
        }
        //return pdfObj;
    }
}

export default {
    name: "CarPdf",
    components: {
        VuePdfEmbed: window.VuePdfEmbed
    },
    mixins: [
        errorHandling,
        tenantInfoMixin,
        splUrlMapMixin,
    ],
    props: {
        title: {  // only used in the heading above the PDF viewer for now
            type: String,
            default: 'Corrective Action Report',
        },
        taskId: {
            type: String,
            required: true,  // must be a taskId for a Corrective Action Report task
            // example one:  xP1mOLuaRhB67r6R4Sys2p
        },
        extraImages: {  // if you have extra images to pass in to pdfmake 'images' dictionary, do it here
            // key = whatever key you'll use in {image: someKey}, value = url or dataUrl (base64)
            type: Object,
            required: false,
        },
        workflowFiles: {
            // pass in a complete list of file objects (your serialized objects) likely which you already have from get_form_data endpoint
            // if this is not set, and not set to an ARRAY, we will refetch everything locally
            type: Array,
            required: false,
        },
        // IF YOU PASS __BOTH__ taskData and formVersionData from parent, then this does not do any fetching of its own
        taskData: {  // should be in SAME FORMAT as returned from API
            type: Object,
            required: false,
        },
        formVersionData: {  // should be in SAME FORMAT as returned from API
            type: Object,
            required: false,
        }
    },
    data: function () {
        return {
            errorMsg: "Error",
            error: false,
            pdfMake: null, // will get from window in created()
            //pdfFonts: null, // will get from window in created()
            pdfComplete: false, 
            iframeRef: null, // will get in mounted()
            documentDefinition: null, // set to docDef on created
            pdfDoc: null, // will put the generated document here - result of pdfMake.createPdf(this.documentDefinition)
            // CONTENT THINGS -- make dynamic later
            //title: 'Document Title',
            downloadFilename: 'corrective_action_report.pdf',
            // TASK DATA
            // now a prop - taskId: 'xP1mOLuaRhB67r6R4Sys2p',  // dynamic later
            loadingTask: false, 
            // taskStateOk: false, // moved to computed  // if task is not in a state that makes sense to show report, then set this true
            task: null,  // full task data object, either from props (set uring created from taskData) or from api call
            needDataFromApi: true,  // if we DO NOT have taskData and formVersionData from props, then this should be true so we make API call
            existingData: null,
            schema: null,  
            formVersion: null,  // full data object, either from props (set during created) or from api call
            formData: null, 
            //workflowRunData: null,  // from separate api call
            standardImages: {  // some 'default' images we'll make available
                //tenantLogo: 'https://supplios-content-useast1.s3.amazonaws.com/media/public/public-files/logos/orgt2vql1eim7os/acme-logo-new-2.png',
                //suppliosLogoDark: 'https://hq.supplios.com/static/img/supplios_0705_dark.png',
                //suppliosLogoWhite: 'https://hq.supplios.com/static/img/supplios_0705_dark.png',
                suppliosLogoDark: '/static/img/supplios_0705_dark.png',
                suppliosLogoWhite: '/static/img/supplios_0705_dark.png',
            },
            images: {},  // we will collect all images from many places and stash here
            // can pass in images in extraImages prop (we put into this.images in created())
            allWorkflowFiles: [],  // ARRAY of serialized s3 file objects - we either get from prop workflowFiles, or we get when fetching data
            // or pass as you fetch other times
            // but before we generate the final output, we will check to make sure we have the image in here, or else we won't add it to PDF, so the timing of when you add stuff here does matter!
            fileUrls: {},
            fileDataUrls: {},  // start with an object so you can use this.$set to add things to it
            formioObjects: null,  // set this in your parser -- array of component objects (your own)
            formioForPdf: null,  // output in PDF structure -- array
            // for showing in b-embed iframe
            pdfDataUrl: null,  // put the dataUrl here when ready 
            // for vue-pdf-embed
            pageCount: null,  // can get from vue-pdf-embed component via $refs - .pageCount // this.$refs.pdfRef.pageCount
            currentPage: 1,  // 1-based index of pages, set to null to show all pages 
            // dimensions for controlling the aspect ratio
            sizeObserver: undefined,  // setup in mounted()
            outerWidth: undefined,  // set from ResizeObserver callback, setup in mounted()
            outerHeight: undefined, 
            calculatedHeight: undefined,  // we calculate this with big formula, set when resized
            calculatedEmbedHeight: undefined,  // actually we want to set this one
            canvasPaddingX: 20,  // number of pixels you want for padding left/right - used in size calculations
            canvasPaddingY: 20,  // same, but for top/bottom
            sizeSetting: 'a4',  // can have different settings here for different paper types, etc -- will set the height of the content area
            // fyi, a4 paper is 210mm x 297mm
        };
    },
    computed: {
        taskStateOk() {
            return this.task?.is_completed;
        },
        hasPdf() {
            // did we successfully build the PDF?
            return !!this.pdfDoc;
        },
        hasPdfDataUrl() {
            return !!this.pdfDataUrl;
        },
        pdfEmbedOuterStyle() {
            return {
                height: `${this.calculatedEmbedHeight}px`,
                minHeight: `${this.calculatedEmbedHeight}px`,
            }
        },
        pdfEmbedInnerStyle() {
            return {
                paddingLeft: `${this.canvasPaddingX}px`,
                paddingRight: `${this.canvasPaddingX}px`,
                paddingTop: `${this.canvasPaddingY}px`,
                paddingBottom: `${this.canvasPaddingY}px`,
            }
        }
    },
    created() {
        // make sure we have window.pdfMake and window.pdfFonts
        /*  or can import this way if you npm installed
        import pdfMake from "pdfmake/build/pdfmake";
        import pdfFonts from "pdfmake/build/vfs_fonts";
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
        */
        if (window.pdfMake) {
            this.pdfMake = window.pdfMake;
        } else {
            console.log("Could not get pdfMake from window!");
        }
        // if using vue-pdf-embed (vue2-pdf-embed)
        if (!window.VuePdfEmbed) {
            console.log('NO window.VuePdfEmbed - so maybe cannot render');
        }
        /* if (window.pdfFonts) {  // seems this gets configured automatically if you have both script tags on the page
            this.pdfFonts = window.pdfFonts;
        } else {
            console.log("Could not get pdfFonts from window!");
        } */
        // and extraImages to add in? -- DOING THIS LATER INSTEAD
        /* if (this.extraImages) {
            this.images = Object.assign({}, this.images, this.extraImages);
        } */
    },
    async mounted() {
        this.sizeObserver = new ResizeObserver(this.updateOuterDimensions);
        this.sizeObserver.observe(this.$el);
        // for data and making PDF
        await this.getTaskData();  // gets the schema/data from API (if needed) -- AND process it how we need it
        await this.parseSchema();  // converts schema/data to PDF structure
        this.buildDocDef();  // build the PDF document definition
        // then finally create the PDF and mount in DOM
        this.createPdf();
        this.pdfToDataUrl();
        /* this.iframeRef = this.$refs["pdf-iframe"];  // grab the ref for later
        if (this.iframeRef) {
            this.mountIFrame();
        } else {
            console.log("Could not get iframe ref!");
        } */
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
        async gatherImages() {
            // gather all images for the complete pdfmake image 'dictionary' -- a JS object that will go into DocDef with URLs or dataURLs of all the images you need for the file (at least the ones that you want to reference by 'name')
            // we will set it on this.images
            // we do this before parseSchema() -- so we can pass it to all the class instances so they can check if a file is in here before trying to output it
            const allImages = {};  // what we're building up
            // DO we have tenant logo?  if so, add that, and you'll refer to it as 'tenantLogo'
            //const tenantLogoUrl = this.tenantInfo?.settings?.logo_url;
            const tenantLogoUrl = this.$splUrlMap.tenant_logo; // '/orgs/logo/';  // might return 404 if there is no logo for this tenant
            /* // BELOW ONLY WORKS IF WE HAVE CORS CONFIGURED CORRECTLY - must send Origin header to S3, but pdfmake does that, and we can't figure out how to tell it to send that header... so we'll fetch it ourselves and stash it in dataURL images
            if (tenantLogoUrl) {  // IF you have a company logo file, add it to imageDict under 'tenantLogo'
                Object.assign(allImages, {tenantLogo: tenantLogoUrl});
            } */
            // FETCHING THE TENANT LOGO AND STASHING AS BASE64 dataURL
            if (tenantLogoUrl) { // if we have it, we'll fetch it and convert to dataURL
                await this.setFileDataUrl('tenantLogo', tenantLogoUrl);
            }
            if (this.standardImages) {
                // if you have any standard/default images, merge them in
                Object.assign(allImages, this.standardImages);  
            }
            const filesFrom = 'dataUrl';  // or 'dataUrl' -- a toggle just for our testing purposes
            if (filesFrom === 'url' && this.fileUrls) {
                // if you are using 'url' for images (instead of dataUrl) - merge them in
                Object.assign(allImages, this.fileUrls);
            }
            if (filesFrom === 'dataUrl' && this.fileDataUrls) {
                // if you are using 'dataUrl' for images (instead of url) - merge them in
                Object.assign(allImages, this.fileDataUrls);
            }
            if (this.extraImages) {  // any extra images?  merge them in
                Object.assign(allImages, this.extraImages); 
            }
            this.images = allImages;  // store it on this.images
            return this.images;  // and return it to caller
        },
        buildDocDef() {
            // make the document and set on this.documentDefinition
            const contentArray = [];
            // add first page
            contentArray.push(this.makePageOne());
            contentArray.push(makeTocPage());
            if (this.formioForPdf && Array.isArray(this.formioForPdf)) {
                this.formioForPdf.forEach(pg => {
                    contentArray.push(pg);
                });
            }
            const finalDocDef = cloneDeep(docDef);
            finalDocDef.content = contentArray;
            finalDocDef.footer = this.makeFooter();
            // set all images - make sure you already called gatherImages (or call it again here)
            finalDocDef.images = this.images;
            /* // JUST FOR TESTING
            const filesFrom = 'dataUrl';  // or 'dataUrl'
            if (filesFrom === 'url' && this.fileUrls) {
                if (finalDocDef.images) {
                    finalDocDef.images = { ...finalDocDef.images, ...this.fileUrls };
                } else {
                    finalDocDef.images = { ...this.fileUrls };
                }
            }
            if (filesFrom === 'dataUrl' && this.fileDataUrls) {
                if (finalDocDef.images) {
                    finalDocDef.images = { ...finalDocDef.images, ...this.fileDataUrls };
                } else {
                    finalDocDef.images = { ...this.fileDataUrls };
                }
            }
            if (this.extraImages) {  // any extra images?  merge them in
                Object.assign(finalDocDef.images, this.extraImages); 
            } */
            this.documentDefinition = finalDocDef;
            console.log('done with buildDocDef');
        },
        makeFooter() {
            const tenantName = this.tenantInfo?.tenant_name ?? '';
            return {
                columns: [tenantName, { text: "CONFIDENTIAL", alignment: "right" }],
                color: 'gray',
                fontSize: 10,
                margin: [20, 20, 20, 20],
            };
        },
        makePageOne() {
            const aboveTitle = { text: "Quality Issue - Corrective Action Report", style: "aboveTitle" };
            const title = { text: this.task.workflow_run_title, style: "title" };
            const svgLine = { 
                        svg: '<svg viewBox="0 0 500 10"><line x1="0" y1="5" x2="500" y2="5" stroke="black" /></svg>',
                        margin: [0,20,0,20],
                    };
            const pageOne = {
                stack: [
                    aboveTitle,
                    title,
                    svgLine,
                ],
                style: 'firstpage',
            };
            const tenantLogo = this.images?.tenantLogo;
            if (tenantLogo) {
                // IF you have a tenant logo the images dict (should have added it during gatherImages), add it under the title
                const logoBlock = { image: tenantLogo, fit: [100,100]};
                pageOne.stack.push(logoBlock);
            }
            return pageOne;
            /* return {
                stack: [
                    { text: "Quality Issue - Corrective Action Report", style: "aboveTitle" },
                    //{ text: this.workflowRunData.title, style: "title" },
                    { text: this.task.workflow_run_title, style: "title" },
                    { 
                        svg: '<svg viewBox="0 0 500 10"><line x1="0" y1="5" x2="500" y2="5" stroke="black" /></svg>',
                        margin: [0,20,0,20],
                    },
                    {image: 'companyLogo', fit: [100,100]},
                ],
                //pageBreak: "after",
                style: "firstpage",
            }; */
        },
        createPdf() {
            this.pdfDoc = this.pdfMake.createPdf(this.documentDefinition);
            if (this.pdfDoc) {
                console.log('PDF was created!');
            }
            return this.pdfDoc;
            // can then call other methods that output as Blob, base64, Buffer, dataURL, print or download
        },
        pdfToDataUrl() {
            console.log('starting pdfToDataUrl');
            this.pdfDoc.getDataUrl((dataUrl) => {
                this.pdfDataUrl = dataUrl;
            });
        },
        mountIFrame() {  // this works, just puts it in a plain iframe
            //const pdfDoc = this.createPdf();
            if (!this.taskStateOk || !this.pdfDoc) {
                return;
            }
            this.pdfDoc.getDataUrl((dataUrl) => {
                const targetElement = this.iframeRef;
                const iframe = document.createElement("iframe"); // maybe use vue render instead
                iframe.src = dataUrl;
                iframe.height = '100%';  // then set width and height of parent element
                iframe.width = '100%';
                targetElement.appendChild(iframe);
            });
            this.pdfComplete = true;
            /* 
            const pdfDocGenerator = pdfMake.createPdf(docDefinition);
            pdfDocGenerator.getDataUrl((dataUrl) => {
                const targetElement = document.querySelector('#iframeContainer');
                const iframe = document.createElement('iframe');
                iframe.src = dataUrl;
                targetElement.appendChild(iframe);
            });
            */
        },
        downloadPdf() {
            const defaultFileName = this.downloadFilename;  // (optional) - file name
            //const cb = null;    // (optional) - callback function
            //const options = null;  // (optional) - advanced options see options chapter
            this.pdfDoc.download(defaultFileName);  // takes optional parameters above
        },

        // FETCHING DATA AND SCHEMA
        async getTaskData() {
            this.loadingTask = true;
            // we MAY have data from props, passed from parent -- if we do, use it -- if not, get from API
            const haveTaskFromProps = !!this.taskData?.id;
            const haveFormVersionFromProps = !!this.formVersionData?.id;
            const haveWorkflowFilesFromProps = !!this.workflowFiles && Array.isArray(this.workflowFiles);
            if (haveTaskFromProps && haveFormVersionFromProps && haveWorkflowFilesFromProps) {
                // just set the local values here -- don't 'process' it -- will do that later 
                // use cloneDeep so we don't mutate things in parent unintentionally
                this.task = cloneDeep(this.taskData);
                this.formVersion = cloneDeep(this.formVersionData);
                this.allWorkflowFiles = cloneDeep(this.workflowFiles);
            } else {
                try {
                    // fetches the schema and any existing submissions for this task from our backend
                    const { data } = await suppliosApi.workflowTask.get_form_data(this.taskId);
                    // will have { task, form_version, form, workflow_context, files } full objects
                    // seems we don't need form here (just form_version) -- but available if needed
                    this.task = data.task;
                    this.formVersion = data.form_version;
                    const workflowFileList = data.files;
                    this.allWorkflowFiles = (!!workflowFileList && Array.isArray(workflowFileList)) ? workflowFileList : [];
                } catch (err) {
                    this.apiErrorHandler(err);
                }
            }
            // now 'process' that data -- however way you got it, same
            await this.buildTaskData(); // integrated all 'processing' things in here
            //this.setFormVersionData(data.form_version);
            this.loadingTask = false;
        },
        async buildTaskData() {
            // MAKE SURE this.task and this.formVersion are already set!
            if (!this.task || !this.formVersion) {
                console.error('From CAR PDF component, cannot build task data because we are missing this.task or this.formVersion');
            }
            // ALSO - replace file URLs, and any other prep-work for the submission data before passing to actual form
            // files will be in this.allWorkflowFiles -- either from prop, or from API
            const allFiles = this.allWorkflowFiles ?? [];  // array of any task files
            const filesById = Object.fromEntries(allFiles.map(file => ([ file.id, file.download_url ])));  // pull out the download_url, to replace the one stored in form submission data as 'url'
            this.fileUrls = Object.assign({}, filesById);
            // now convert the image URLs to data URLs -- easier to put in PDF that way
            // using forEach with async/await does not work how you expect... use Promise.all(map()) instead - map should return a promise you want to wait on -- can do that just by making internal anonymous function an async one (which always returns a promise)
            await Promise.all(Object.entries(this.fileUrls).map(async ([fileId, freshUrl]) => {
                console.log('freshUrl for this image:', freshUrl);
                await this.setFileDataUrl(fileId, freshUrl);
            }))
            // then we pass this.fileUrls to the child formio-form component, which replaces them for the old URLs when it sets submission
            console.log('from buildTaskData, here is task object', this.task);
            this.existingData = cloneDeep(this.task.submission_data);
            this.schema = this.formVersion.schema;
            return true;
        },
        /* setFormVersionData(formVersionData) {
            // set local data from API response
            this.schema = formVersionData.schema;
            this.formVersion = formVersionData;
            //this.parseSchema(this.schema);
        }, */
        async parseSchema() {
            // convert formio schema into things for PDF
            // MAKE SURE ALL THE DATA SOURCES (INCLUDING IMAGES) ARE GATHERED AND READY BY THE TIME YOU GET HERE -- THIS DEPENDS ON IT
            console.log('starting parseSchema, which outputs things using forPdf()');
            const imageDict = await this.gatherImages();  // also sets it on this.images
            const schemaComponents = this.schema.components;
            this.formioObjects = schemaComponents.map(pageComp => new FormioComponent(pageComp, 0, '', this.existingData, this.fileUrls));
            this.formioForPdf = this.formioObjects.map(fo => fo.forPdf({imageDict})).filter(pObj => !!pObj);
        },
        /* setDataUrlForImageUrl(fileId, url) {
            const toDataUrl = (imageUrl) => {
                fetch(imageUrl)
                .then(data => data.blob().then(blob => {
                    const reader = new FileReader();
                    reader.onloadend = () =>  {
                        console.log(reader.result);
                    };
                    reader.onerror = () => {
                        console.log('reader error');
                    };
                    reader.readAsDataURL(blob);
                }));
            }
        }, */
        /* getDataUrl(fileId, url) {  // returns a promise -- call from other method
            fetch(url)
            .then(response => response.blob())
            .then(blob => new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.onloadend = () => resolve(reader.result)
                reader.onerror = reject
                reader.readAsDataURL(blob)
            }))
            .then(dataUrl => {
                console.log('do we have dataUrl in the promise?', !!dataUrl);
                this.$set(this.fileDataUrls, fileId, dataUrl);
                return dataUrl;
            });
        }, */
        /* 
            toDataUrl(url)  // 'https://www.gravatar.com/avatar/d50c83cc0c6523b4d3f6085295c953e0'
            .then(dataUrl => {
                console.log('set dataUrl for fileId:', fileId);
                this.fileDataUrls[fileId] = dataUrl;
                return true;
            });
        }, */
        // OLD VERSION that worked with this.getDataUrl() -- trying new version below
        /* async setFileDataUrl(fileId, url) {
            try {
                const dataUrl = await this.getDataUrl(fileId, url);
                console.log('got fileDataUrl for fileId', fileId, dataUrl);
                //this.fileDataUrls[fileId] = dataUrl;
                //this.$set(this.fileDataUrls, fileId, dataUrl);
            } catch (err) {
                console.log('Error while getting file URLs');
            }
            //return true;
        }, */
        async setFileDataUrl(fileId, url) {  // works, but async stuff is messed up
            // from here:  https://dev.to/sbodi10/download-images-using-javascript-51a9
            //const url = 'https://supplios-content-useast1.s3.amazonaws.com/media/public/public-files/logos/orgt2vql1eim7os/acme-logo-new-2.png';
            /* const fetchInitOptions = {
                referrer: 'http://sub2.test.local:8000',
                mode: 'cors',
                //credentials: 'include',
                referrerPolicy: 'origin-when-cross-origin',  // send the Origin header when making a cross-origin request -- S3 needs this to send back response header for CORS
            }; */  // see more: https://developer.mozilla.org/en-US/docs/Web/API/fetch
            const imageResp = await fetch(url);
            if (!imageResp.ok) {
                // if NOT ok status code (2xx)
                // MIGHT be caused by a 404 on the tenant logo url -- if so, we want to swallow it
                console.warn(`Got error while fetching image for PDF - fileId = ${fileId} and URL = ${url}`);
                console.warn(`Status code: ${imageResp.status} - Status text: ${imageResp.statusText}`);
                // now just return a promise that resolves to something... false makes sense here 
                return Promise.resolve(false);
            }
            const imageBlob = await imageResp.blob();
            console.log('got the image Blob - type is: ', imageBlob.type);
            // gotta wrap ALL this reader stuff in its own promise, or else doesn't work (likely because the reader reads, but onloadend event gets fired and handled later, not all syncronously)
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                // simple function to stash things -- use it below
                /* const setDataUrl = (dataUrl) => {
                    this.$set(this.fileDataUrls, fileId, dataUrl);
                } */
                // reader emits 'loadend' when its done, so have to set callback on that, then do something with reader.result
                reader.onloadend = () => {
                    console.log('loadend fired!');
                    const dataUrl = reader.result;
                    this.$set(this.fileDataUrls, fileId, dataUrl);
                    //setDataUrl(dataUrl);
                    resolve(true);
                }
                reader.onerror = reject;  
                reader.readAsDataURL(imageBlob);  // actually do the read... when done onloadend will be called
            });
        },
        // for working with vue-pdf-embed
        handlePdfEmbedRender() {
            console.log('pdf rendered in vue-pdf-embed');
            this.pageCount = this.$refs.vuePdfEmbedRef?.pageCount;
            // can set :page prop on the embed component to null to show all pages, or one specific page to show just that, control with buttons
        },
        updateOuterDimensions() {
            const el = this.$el;
            this.outerWidth = el.offsetWidth;
            this.outerHeight = el.offsetHeight;
            this.calculatedHeight = this.getCalculatedHeight();
            //this.$emit('resize', arguments);
        },
        getCalculatedHeight() {  // returns a NUMBER (in pixels)
            // do the calculations, based on sizeSetting and current observed dimensions
            // overallWidth - 2 * borderWidths - 2 * canvasPaddingX = 'paper' size (canvas size)
            const outerBorderWidth = 1;
            const canvasX = (this.outerWidth ?? 0) - (2 * outerBorderWidth) - (2 * this.canvasPaddingX) 
            console.log('canvasX', canvasX);
            const getCanvasY = (heightOverWidthRatio) => {
                return canvasX * heightOverWidthRatio;
            }
            let ratio = 1;  // switch statement??? i hate those...
            if (this.sizeSetting === 'a4') {
                ratio = 1.414;
            } else if (this.sizeSetting === 'letter') {
                ratio = 1.294;
            }// ...add other sizes as needed
            const canvasY = getCanvasY(ratio);
            console.log('canvasY', canvasY);
            this.calculatedEmbedHeight = Math.round(canvasY + (2 * this.canvasPaddingY));
            const controlBar = this.$refs.pdfControlBar;
            const controlBarHeight = controlBar ? controlBar.offsetHeight : 0;
            console.log('controlBarHeight', controlBarHeight);
            const overallHeight = this.calculatedEmbedHeight + controlBarHeight + (2 * outerBorderWidth);
            return Math.round(overallHeight);  // number of pixels
        },
        // DOCUMENT ELEMENTS - return new object each time you make one -- otherwise they get shared/mutated
        makePanelTitle(text) {
            return {
                //layout: 'noBorders',
                margin: [0,5,0,5],
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                text: text,
                                fillColor: '#eeeeee',
                                border: [false, false, false, false],
                                bold: true,
                                color: 'darkblue',
                                paddingLeft: 20,
                            }
                        ]
                    ]
                }
            }
        } 
    },
};
</script>

<style lang="scss">
.pdf-embed-wrapper {
    canvas {
        // this is the actual pdf page
        box-shadow: $box-shadow;
    }
}
</style>